export default {
  userInfo: {},
  shopItems: null,
  providerItems: null,
  addressList: null,
  addressId: null,
  currentTab: 0,
  rxShadeConfig: {
    'shop-compliance-open': true,
    'shop-compliance-content': {
      tips: '处方药依法规不展示包装',
      textColor: '000000',
      textSize: 14,
      alpha: '0.6',
      bgColor: 'ffffff'
    }
  }
};
